module.exports = require("./ar-IL");